import { Loader } from "@/components/loader";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { getDrugList, getDrugListExport } from "../../../api/group";
import PillIcon from "../../../assets/SVG/pillIcon";
import SearchInput from "../../project/searchInput";
import DrugTable from "./drugTable";

export default function DetailsDrug({ setMode, notGroup }) {
  const [dataTable, setDataTable] = useState();
  const [valueSearch, setValueSearch] = useState("");

  const [pageable, setPageable] = useState({
    pageSize: 10,
    pageIndex: 0,
  });
  const [showAddDrugToAreaFrom, setShowAddDrugToAreaFrom] = useState(false);
  const [totalSize, setTotalSize] = useState();
  const [lastFetch, setLastFetch] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [validValueSearch, setValidValueSearch] = useState();

  const fetchDrugs = useCallback(() => {
    if (lastFetch !== undefined && Date.now() - lastFetch < 500) return;
    setLoading(true);
    const query = new URLSearchParams();
    query.append("pageIndex", pageable.pageIndex);
    query.append("pageSize", pageable.pageSize);
    if (validValueSearch && validValueSearch.length > 1) {
      query.append("name", validValueSearch);
    }
    setDataTable([]);
    getDrugList(query)
      .then((x) => {
        setTotalSize(x.totalElements);
        setDataTable(x.content);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
        setLastFetch(Date.now());
      });
  }, [pageable, validValueSearch]);

  useEffect(() => {
    fetchDrugs(false);
  }, [pageable, validValueSearch]);

  const [timer, setTimer] = useState();

  useEffect(() => {
    if (timer !== undefined) {
      clearTimeout(timer);
    }

    if (
      valueSearch.length >= 3 ||
      (valueSearch.length === 0 && validValueSearch !== undefined)
    ) {
      const timer = setTimeout(() => {
        setValidValueSearch(valueSearch.length >= 3 ? valueSearch : undefined);
        setPageable({
          pageIndex: 0,
          pageSize: pageable.pageSize,
        });
        setTotalSize(undefined);
      }, 500);

      setTimer(timer);
    }

    return () => {
      if (timer !== undefined) {
        clearTimeout(timer);
      }
    };
  }, [valueSearch]);

  return (
    <Box>
      {loading && <Loader />}

      {!showAddDrugToAreaFrom && (
        <>
          <Box display="flex" gap="10px">
            <Box
              display="flex"
              onClick={() => setMode("new")}
              sx={{ cursor: "pointer" }}
              alignItems={"center"}
            >
              <PillIcon />
              <Typography
                fontWeight={"bold"}
                color="var(--emr-primary)"
                fontSize="16px"
                mr="10px"
              >
                دارو جدید
              </Typography>
            </Box>
            <Typography color="white" fontSize="20px">
              |
            </Typography>
            <Box
              display="flex"
              onClick={() => setMode("addBatchToArea")}
              sx={{ cursor: "pointer" }}
              alignItems={"center"}
            >
              <PillIcon />
              <Typography
                fontWeight={"bold"}
                color="var(--emr-primary)"
                fontSize="16px"
                mr="10px"
              >
                افزودن دسته جمعی دارو به منطقه
              </Typography>
            </Box>
          </Box>
          <Grid
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            mt={"20px"}
          >
            <Grid display={"flex"} flexDirection={"row"} gap={"20px"}>
              <SearchInput
                type="text"
                value={valueSearch}
                onChange={(e) => setValueSearch(e.target.value)}
              />
              {valueSearch.length >= 2 && (
                <Button
                  onClick={() => {
                    setValueSearch("");
                    setValidValueSearch(undefined);
                    setTotalSize(undefined);
                    setPageable({
                      pageIndex: 0,
                      pageSize: pageable.pageSize,
                    });
                  }}
                >
                  پاک کردن فیلتر
                </Button>
              )}
            </Grid>

            <Button
              disabled={loadingExcel}
              sx={{ fontFamily: "Vazirmatn" }}
              variant="outlined"
              onClick={() => {
                setLoadingExcel(true);
                const query = new URLSearchParams();
                if (valueSearch && valueSearch.length > 1) {
                  query.append("searchKey", valueSearch);
                }
                getDrugListExport(query)
                  .then((x) => {
                    const blob = new Blob([x], {
                      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = `drugs.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                    setLoadingExcel(false);
                  })
                  .catch(() => {
                    setLoadingExcel(false);
                  });
              }}
            >
              خروجی اکسل
            </Button>
          </Grid>
        </>
      )}
      <DrugTable
        totalElements={totalSize}
        onPageChange={(pageIndex, pageSize) => {
          setPageable({
            pageIndex: pageIndex,
            pageSize: pageSize,
          });
        }}
        notGroup={notGroup}
        rowData={dataTable}
        setRowData={setDataTable}
        pageSize={pageable.pageSize}
        currentPage={pageable.pageIndex}
        showAddDrugToAreaFrom={showAddDrugToAreaFrom}
        setShowAddDrugToAreaFrom={setShowAddDrugToAreaFrom}
      />
    </Box>
  );
}
